"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
var catalog_1 = require("../utils/catalog");
var constant_1 = require("../utils/constant");
var wrapper_1 = require("../utils/wrapper");
var fetch = function (companyCode) {
    return wrapper_1.getClients()
        .elasticClient.get(constant_1.ELASTIC_SAAS_CATALOG_SEARCH_URL + "?q=companyCode:" + companyCode)
        .then(function (_a) {
        var data = _a.data;
        return catalog_1.catalogsResponseFactory(data);
    });
};
var catalog = {
    fetch: fetch,
};
var init = function () { return catalog; };
exports.init = init;
